import _extends from "@babel/runtime/helpers/extends";
import _map from "lodash/map";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.function.name.js";
import React from 'react';
import PropTypes from 'prop-types';
import { Text, Box, Link } from '@nerdwallet/currency';
import Expandable from './fly-out-header-expandable';
import './fly-out-header-section.less';

function processUrl(sectionUrl, sectionName, pageSection) {
  if (sectionName === pageSection) {
    var urlAnchor = sectionUrl.split('#').pop();
    return "#".concat(urlAnchor);
  }

  return sectionUrl;
}

var FlyOutHeaderSection = function FlyOutHeaderSection(_ref) {
  var name = _ref.name,
      url = _ref.url,
      subsections = _ref.subsections,
      pageSection = _ref.pageSection,
      isNavOpen = _ref.isNavOpen,
      setIsNavOpen = _ref.setIsNavOpen;
  var processedUrlValue = processUrl(url, name, "".concat(pageSection));
  var returnNav = /*#__PURE__*/React.createElement("li", {
    key: "fly-out-header__section-".concat(processedUrlValue),
    className: "fly-out-header__section"
  }, /*#__PURE__*/React.createElement(Link, {
    href: processedUrlValue,
    className: "fly-out-header__section--link"
  }, name && /*#__PURE__*/React.createElement(Box, {
    className: "fly-out-header__section--name"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, name))));

  var subnavSection = _map(subsections, function (subsection, index) {
    var processedSubUrlValue = processUrl(subsection.url, name, "".concat(pageSection));
    return /*#__PURE__*/React.createElement("li", {
      key: "fly-out-header__subnav-".concat(index),
      className: "fly-out-header__subnav--cont"
    }, /*#__PURE__*/React.createElement(Link, {
      href: processedSubUrlValue,
      className: "fly-out-header__subnav--link",
      onClick: function onClick() {
        return setIsNavOpen(!isNavOpen);
      }
    }, subsection.name && /*#__PURE__*/React.createElement(Box, {
      className: "fly-out-header__subnav--name"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, subsection.name))));
  });

  var processedSubnavSection = /*#__PURE__*/React.createElement("ul", null, subnavSection);
  var expandableContent = {
    title: "".concat(name),
    copy: [processedSubnavSection]
  };
  var returnSubnav = /*#__PURE__*/React.createElement(Expandable, _extends({}, expandableContent, {
    id: "fly-out-header__subnav"
  }));
  return subsections !== null ? returnSubnav : /*#__PURE__*/React.createElement("ul", null, returnNav);
};

FlyOutHeaderSection.propTypes = {
  pageSection: PropTypes.string,
  isNavOpen: PropTypes.bool,
  name: PropTypes.string,
  url: PropTypes.string,
  setIsNavOpen: PropTypes.number,
  subsections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string
  }))
};
FlyOutHeaderSection.defaultProps = {
  pageSection: '',
  name: '',
  url: '',
  subsections: null
};
FlyOutHeaderSection.displayName = 'FlyOutHeaderSection';
export default FlyOutHeaderSection;